/* global axios */
import ApiClient from './ApiClient';

class KanbanAutomationsAPI extends ApiClient {
  constructor() {
    super('kanban_automations', { accountScoped: true });
  }

  list(pipelineId, columnId) {
    return axios.get(this.url, {
      params: { pipeline_id: pipelineId, column_id: columnId },
    });
  }

  createAutomation(data) {
    return axios.post(this.url, { kanban_automation: data });
  }

  updateAutomation(id, data) {
    return axios.patch(`${this.url}/${id}`, { kanban_automation: data });
  }

  deleteAutomation(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getLogs(id) {
    return axios.get(`${this.url}/${id}/logs`);
  }
}

export default new KanbanAutomationsAPI();
